import { useCallback, useMemo } from 'react';
import { applyExcelFormats } from '../../../../utils/excel';
import { REWARDS_LOG_COLUMNS } from '../../../../constants/reports';
import { exportReportFile, processReport } from '../../../../utils/reports';
import ReportActionRow from '../ReportActionRow';
import ReportList from '../ReportList';
import { getTextWidthInOneLine } from '../../../../utils/strings';

function ReportRewardsLog({
  reportTitle,
  reportDetails,
  reportId,
  reportFileName,
  reportType,
  setSpinner,
  report,
}) {
  const { processedReport } = useMemo(
    () => processReport(reportType, report),
    [reportType, report],
  );

  const formattedReport = useMemo(() => {
    if (processedReport.length > 0) {
      return processedReport.map(r =>
        Object.entries(r).reduce(
          (acc, [key, value]) => ({
            ...acc,
            [key]: applyExcelFormats(value, REWARDS_LOG_COLUMNS[key]?.style?.numFmt),
          }),
          {},
        ),
      );
    }

    return [];
  }, [processedReport]);

  const getRowHeight = useCallback(
    index => {
      const descriptionWidthInOneLine = getTextWidthInOneLine(formattedReport[index].description);

      return Math.max(
        descriptionWidthInOneLine > 50 * 6 - 16
          ? Math.ceil((descriptionWidthInOneLine / (50 * 6)) * 20) + 36
          : 0,
        36,
      );
    },
    [formattedReport],
  );

  return (
    <>
      <ReportActionRow
        reportTitle={reportTitle}
        reportDetails={reportDetails}
        reportId={reportId}
        setSpinner={setSpinner}
        exportFile={() => exportReportFile({ reportType, reportFileName, report })}
      />
      <ReportList
        report={formattedReport}
        tableColumns={REWARDS_LOG_COLUMNS}
        headerHeight={36}
        getRowHeight={getRowHeight}
        rowKey="id"
      />
    </>
  );
}

export default ReportRewardsLog;
